import React from "react";
import { Grid, Header, Label } from "semantic-ui-react";
import SimpleSelectComponent from "../forms/SimpleSelectComponent";
import { formatDate, formatSecondsToTime } from "../../helpers/datetime";
import { HUMAN_DATE_FORMAT } from "@common/constants/datetime";
import { formatCurrency } from "../../helpers/currency";

const CounterLabel = (label, index) => (
  <Header className="m-0_5" as="h5" key={`${label}_${index}`}>
    {label.label}: {label.value}
  </Header>
);

const CustomerHeader = ({ props }) => {
  const {
    name,
    currentTab,
    selectedSummaryRecord,
    selectedCustomerStatus,
    customerStatus,
    customerStatusOptions,
    onCustomerStatusChange,
    optionAllowCustomerStateChange,
    dateOfReturn,
    className,
    sessionStats,
  } = props;

  const customerLabels = [
    {
      label: "Latest Risk Score",
      value: selectedSummaryRecord?.customer?.riskScore ?? "N/A",
    },
    {
      label: "Culmulative Risk Score",
      value: selectedSummaryRecord?.customer?.customerStats?.cumulativeRiskScore
        ? Number(
            selectedSummaryRecord?.customer?.customerStats?.cumulativeRiskScore.toFixed(
              1,
            ),
          )
        : "N/A",
    },
    {
      label: "Interaction Count",
      value:
        selectedSummaryRecord?.customer?.customerStats?.interactionCount ??
        "N/A",
    },
  ];

  const sessionsLabels = [
    {
      label: "Avg. Session Net Loss",
      value:
        sessionStats?.averageSessionNetLoss != null
          ? formatCurrency(sessionStats.averageSessionNetLoss)
          : "N/A",
    },
    {
      label: "Avg. Session Duration",
      value:
        sessionStats?.averageSessionTimeOnGame != null
          ? formatSecondsToTime(sessionStats.averageSessionTimeOnGame)
          : "N/A",
    },
    {
      label: "Avg. Session Spend",
      value:
        sessionStats?.averageSessionSpend != null
          ? formatCurrency(sessionStats.averageSessionSpend)
          : "N/A",
    },
  ];

  return (
    <Header size="medium" className={className}>
      <span className="text-sm">{name}</span>
      {optionAllowCustomerStateChange && (
        <Header.Subheader className="mt-2 mt-2em">
          <Grid verticalAlign="center">
            <Grid.Row className="p-0">
              <SimpleSelectComponent
                name="customerStatus"
                placeholder="Select customer status"
                options={customerStatusOptions}
                value={
                  selectedCustomerStatus
                    ? selectedCustomerStatus?.value
                    : customerStatus?.value
                }
                onChange={onCustomerStatusChange}
              />
            </Grid.Row>
            {(selectedSummaryRecord?.customer?.isTakingABreak ||
              customerStatus?.value === "isTakingABreak") && (
              <Grid.Row>
                <Label basic color="red">
                  <span>Returning </span>
                  {formatDate(dateOfReturn, HUMAN_DATE_FORMAT)}
                </Label>
              </Grid.Row>
            )}
            <Grid.Row>
              {currentTab === 2
                ? sessionsLabels.map((x, index) => CounterLabel(x, index))
                : customerLabels.map((x, index) => CounterLabel(x, index))}
            </Grid.Row>
          </Grid>
        </Header.Subheader>
      )}
    </Header>
  );
};

export default CustomerHeader;
